var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M7.7,0,4.89,2.82,14.05,12,4.89,21.18,7.7,24l12-12Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }